<template>
    <div class="">
        <div class="">
            <div class="" :id="'coll-trigger-' + orderId" @click.prevent="setActiveStatus($event)">

                <slot name="header"></slot>

<!--                <slot name="arrow">-->
<!--                    <span class="down-Arrow" v-show="!active">&#9660;</span>-->
<!--                    <span class="up-Arrow" v-show="active">&#9650;</span>-->
<!--                </slot>-->
            </div>
        </div>
        <div class="tab__content p-2" :id="'coll-' + orderId" v-show="active"><slot /></div>
    </div>
</template>

<script>
export default {
    name: 'Collapsible',

    props: {
        orderId: {
            required: false
        }
    },

    data() {
        return {
            active: false,
        }
    },

    methods: {
        setActiveStatus(event){
            if (event.target.classList.contains('go-to-transactions-button')) {
                document.getElementById('coll-' + this.orderId).style.display = 'block';
                document.getElementById('coll-header-' + this.orderId).classList.add('highlight');
                document.getElementById('coll-arrow-' + this.orderId).classList.add('open');
                document.getElementById('payments-' + this.orderId).scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    blockOffset: 0,
                });

                this.active = true;
            } else if(event.target.classList.contains('continue-payment-button')) {
                window.location.href = event.target.href
            } else {
                this.active = !this.active;

                document.getElementById('coll-header-' + this.orderId).classList.toggle('highlight');
                document.getElementById('coll-arrow-' + this.orderId).classList.toggle('open');
            }
        }
    }
}
</script>

<style scoped>

</style>
